import { ApiRequest, ApiRequestNoLoder, getHost, getUserId } from "../../services/api";

export const PostGeneratePrompt = async (data) => {
  return await ApiRequest("PUT", "generate-prompt-payload", data);
};

export const PostStorePrompt = async (data) => {
  return await ApiRequest("POST", "store-prompt-response", data);
};

export const PostDisconnectWhatsAppBiodata = async () => {
  return await ApiRequest(
    "POST",
    "admin/whatsapp-biodata/connection/disconnect",
    {},
  );
};
export const PostUploadWhatsAppBiodata = async (formData) => {
  return await ApiRequest(
    "POST",
    "admin/whatsapp-biodata/uploads",
    formData,
  );
};
export const PostUploadOnboardingBiodata = async (formData) => {
  return await ApiRequest(
    "POST",
    "admin/whatsapp-biodata/onboarding-export/uploads",
    formData,
  );
};
export const PostBiodataNonUserExport = async (formData) => {
  return await ApiRequest("POST", "admin/v2/biodata-non-user-export", formData);
};
export const PostUpdatePrompt = async (data) => {
  return await ApiRequest("PATCH", "update-prompt", data);
};
export const PostMatchedProfileData = async (data) => {
  return await ApiRequest("PUT", "get_matched_profile", data);
};
export const PostUpdateInQueue = async (data) => {
  return await ApiRequest("POST", "update-in-queue", data);
};
export const DeactivateDataCheckRows = async (key, ids) => {
  return await ApiRequest("POST", `admin/data-checks/${encodeURIComponent(key)}/deactivate`, { ids });
};
export const DeleteDataCheckRows = async (key, ids) => {
  return await ApiRequest("POST", `admin/data-checks/${encodeURIComponent(key)}/delete`, { ids });
};
export const PostLogin = async (data) => {
  return await ApiRequest("POST", "admin/v2/admin-login", data);
};
export const PostMessage = async (data) => {
  return await ApiRequest("POST", "whatsapp/messages", data);
};
export const PostUserWhatsappChatMessage = async (userId, data) => {
  return await ApiRequestNoLoder(
    "POST",
    `admin/v2/users/${encodeURIComponent(userId)}/whatsapp-chat/messages`,
    data,
  );
};
export const PostForceMatchAdmin = async (data) => {
  return await ApiRequest("POST", "force-match-making", data);
};
export const PostForceMatchmakingAdmin = async (data) => {
  return await ApiRequest("POST", "admin/v2/force-matchmaking", data);
};
export const PostChatRequest = async (data) => {
  return await ApiRequest("POST", "whatsapp/messages/chat-request", data);
};
export const PostMarkRead = async (data) => {
  return await ApiRequestNoLoder("POST", "whatsapp/messages/mark-read", data);
};

export const PostTeamActivityAcknowledge = async (data) => {
  return await ApiRequestNoLoder("POST", "admin/v2/team-member-activity/acknowledge", data);
};

export const PostPublishProfile = async (data) => {
  return await ApiRequest("POST", "publish-match", data);
};

// Admin force-publish that overrides waivable gate violations (sense + caste + marital) with a
// recorded reason. disliked/blocked are still refused server-side. data: {user_id, candidate_id, both, reason}
export const PostPublishWithOverride = async (data) => {
  return await ApiRequest("POST", "admin/match/publish-with-override", data);
};

export const PostResetMatch = async (userId) => {
  return await ApiRequest("POST", "admin/reset-matches", { userId });
};

export const CreateChatGPTPrompt = async (data) => {
  const formData = new FormData();
  Object.keys(data).forEach(key => formData.append(key, data[key]));
  return await ApiRequest("POST", "admin/v2/chatgpt-prompts", formData);
};
export const PostUploadProfile = async (data) => {
  return await ApiRequest("POST", "upload-profile", data, {
    "Content-Type": "multipart/form-data",
  });
};
export const PostScreenshots = async (data) => {
  return await ApiRequest("POST", "upload-screenshots", data, {
    "Content-Type": "multipart/form-data",
  });
};

export const PostLoginContext = async (data) => {
  return await ApiRequest("POST", "admin/v2/admin-login", data);
};

export const UpdateDecision = async (data) => {
  return await ApiRequest("PUT", "admin-update-decision", data);
};

export const UpdateTagStatus = async (data) => {
  return await ApiRequest("PUT", "admin-update-tag-status", data);
};

export const UpdateCommentrySummary = async (data) => {
  return await ApiRequest("PUT", "admin-update-commentary", data);
};

export const AddPayment = async (data) => {
  return await ApiRequest("POST", "credits/add", data);
};

export const PostAddCreditsToUser = async (data) => {
  return await ApiRequest("POST", "admin/add-credits-to-user", data);
};

export const PostWhatsappPdfMatches = async (data) => {
  return await ApiRequest("POST", "admin/service", data);
};

export const PostQueueService = async (data) => {
  return await ApiRequest("POST", "admin/service", data);
};

export const PostAdminLikeDislike = async (data) => {
  return await ApiRequest("POST", "admin/v2/like-dislike", data);
};

export const PostAdminService = async (data) => {
  return await ApiRequest("POST", "admin/service", data);
};

// Unified Service Job API
// Supports: common-services, force-match, matchmaking, matchmaking-queue, 
// tag-extraction, about-me, publish-match, whatsapp-pdf, question-tags
// Uses ApiRequestNoLoder to allow manual toast handling
export const PostServiceJob = async (data) => {
  return await ApiRequestNoLoder("POST", "service/add-service", data);
};

export const ForcedMatchForSkippedMatch = async (data) => {
  return await ApiRequest("POST", `admin/soft-force-match-run?uid=${data.uid}&cid=${data.cid}`, {});
};

export const PostExecuteQuery = async (data) => {
  return await ApiRequest("POST", "admin/execute-query", data);
};

export const PostPublishMultiple = async (data) => {
  return await ApiRequest("POST", "admin/publish/multiple", data);
};



export const PostInterestedUsers = async (data) => {
  return await ApiRequest("POST", "admin/create/interested-users", data);
};

// SUPER_ADMIN: Create new admin
export const PostCreateAdmin = async (data) => {
  return await ApiRequest("POST", "admin/create-admin", data);
};

export const PostUploadEmployees = async (file) => {
  // Read and normalize Excel data before sending
  const XLSX = await import('xlsx');
  const data = await file.arrayBuffer();
  const workbook = XLSX.read(data);
  const worksheet = workbook.Sheets[workbook.SheetNames[0]];
  const jsonData = XLSX.utils.sheet_to_json(worksheet);

  // Normalize headers for new format
  const normalizeKey = (key) => key.toLowerCase().replace(/[\s.]+/g, '');
  const headerMapping = {
    'name': 'name',
    'mobileno': 'mobile_no',
    'mobile': 'mobile_no',
    'phone': 'mobile_no',
    'instruction': 'instruction',
    'status': 'status',
    'feedback': 'feedback',
    'assignedto': 'assigned_to'
  };

  const normalizedData = jsonData.map(row => {
    const normalizedRow = {};
    Object.keys(row).forEach(key => {
      const normalizedKey = normalizeKey(key);
      const mappedKey = headerMapping[normalizedKey] || key;
      normalizedRow[mappedKey] = row[key];
    });
    return normalizedRow;
  });

  // Create new Excel file with normalized data
  const newWorkbook = XLSX.utils.book_new();
  const newWorksheet = XLSX.utils.json_to_sheet(normalizedData);
  XLSX.utils.book_append_sheet(newWorkbook, newWorksheet, 'Sheet1');
  const normalizedBuffer = XLSX.write(newWorkbook, { type: 'array', bookType: 'xlsx' });
  const normalizedFile = new File([normalizedBuffer], file.name, { type: file.type });

  const formData = new FormData();
  formData.append('file', normalizedFile);

  // Use custom host for this API
  const token = localStorage.getItem('token');
  const response = await fetch('https://api.v2.production.smartmatrimony.ai/admin/upload-excel-users', {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`
    },
    body: formData
  });

  return await response.json();
};

export const PostSendWhatsApp = async (data) => {
  return await ApiRequest("POST", "admin/send-whatsapp", data);
};

export const PostCreateEmployee = async (data) => {
  return await ApiRequest("POST", "admin/employees", data);
};

export const PostTriggerServices = async (userId, approve) => {
  return await ApiRequest("POST", "admin/trigger-services", { userId, approve });
};

export const PostGenerateAboutMe = async (data) => {
  return await ApiRequestNoLoder("POST", "admin/v2/generate-about-me", data);
};

// Attendance APIs
export const PostAttendanceLogin = async (data) => {
  return await ApiRequest('POST', 'employee-attendance/login', data);
};

export const PostAttendanceLogout = async (data) => {
  return await ApiRequest('POST', 'employee-attendance/logout', data);
};

export const PostAttendanceLeave = async (data) => {
  return await ApiRequest('POST', 'employee-attendance/leave', data);
};

export const PostValidateSignupCoupon = async (couponCode) => {
  return await ApiRequestNoLoder("POST", "signup/validate-coupon", {
    coupon_code: couponCode,
  });
};

export const PostGenerateTempPassword = async (userId, validityMinutes = 30) => {
  return await ApiRequest("POST", `admin/generate-temp-password?userId=${userId}&validity_minutes=${validityMinutes}`, {});
};

export const PostVerifyUser = async (userId) => {
  return await ApiRequest("POST", `admin/verify-user?user_id=${userId}`, {});
};

export const PostUpdateUserInstructions = async (data) => {
  return await ApiRequest("POST", "admin/update-user-instructions", data);
};

export const PostUpdateDropdownData = async (category, value, oldValue = null) => {
  const payload = { category, value };
  if (oldValue) {
    payload.old_value = oldValue;
  }
  return await ApiRequest("POST", "admin/update-dropdown-data", payload);
};

export const PostResetMatchingData = async (data) => {
  return await ApiRequest("POST", "admin/reset-matching-data", data);
};

export const PostDeleteDropdownData = async (category, value) => {
  return await ApiRequest("POST", "admin/delete-dropdown-data", { category, value });
};

export const PostUpdatePreferenceValue = async (preferenceTypeId, value, oldValue = null, color = null, iconUrl = null) => {
  const payload = { preference_type_id: preferenceTypeId, value };
  if (oldValue) payload.old_value = oldValue;
  if (color) payload.color = color;
  if (iconUrl) payload.icon_url = iconUrl;
  return await ApiRequest("POST", "admin/update-dropdown-data", payload);
};

export const PostDeletePreferenceValue = async (preferenceTypeId, value) => {
  return await ApiRequest("POST", "admin/delete-dropdown-data", { preference_type_id: preferenceTypeId, value });
};

export const PostSendMatchNotification = async (data) => {
  return await ApiRequestNoLoder("POST", "admin/send-match-notification", data);
};

export const PostSendRequestedMatchTemplate = async (data) => {
  return await ApiRequestNoLoder("POST", "admin/send-requested-match-template", data);
};

export const PostMatchMakingAstrologyDetails = async (data) => {
  const token = localStorage.getItem("token");
  console.log("[PostMatchMakingAstrologyDetails] request payload:", data);
  const response = await fetch("https://api.v2.production.smartmatrimony.ai/admin/match-making-astrology-details", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": token ? `Bearer ${token}` : "",
    },
    body: JSON.stringify(data),
  });

  const responseData = await response.json();
  console.log("[PostMatchMakingAstrologyDetails] response status:", response.status);
  console.log("[PostMatchMakingAstrologyDetails] response data:", responseData);
  console.log("hello",data.candidate.occupation_location);
  return responseData;
};

export const DockerContainerAction = async (action, containerName) => {
  return await ApiRequest("POST", `admin/docker/${action}?container_name=${containerName}`, {});
};

export const PostClearAllCache = async () => {
  return await ApiRequestNoLoder("POST", "admin/cache/clear-all", {});
};

export const PostClearCacheByPath = async (path) => {
  return await ApiRequestNoLoder("POST", "admin/cache/clear-by-path", { path });
};

export const PostClearCacheByPattern = async (pattern) => {
  return await ApiRequestNoLoder("POST", "admin/cache/clear-by-pattern", { pattern });
};

export const PostResetCacheBreaker = async () => {
  return await ApiRequestNoLoder("POST", "admin/cache/breaker/reset", {});
};

export const PostSetCommunity = async (data) => {
  return await ApiRequest("POST", "admin/set-community", data);
};

export const PostMoveToQueue = async (data) => {
  return await ApiRequest("POST", "admin/move-to-queue", data);
};

export const PostMoveToSkipped = async (data) => {
  return await ApiRequest("POST", "admin/move-to-skipped", data);
};

export const PostCommonInstructionDislike = async (data) => {
  return await ApiRequest("POST", "admin/common-instruction-dislike", data);
};

export const PostAgentSimpleChat = async (data) => {
  return await ApiRequestNoLoder("POST", "chat/simple", data, null, true);
};

export const PostAgentConfirmChat = async (data) => {
  return await ApiRequestNoLoder("POST", "chat/confirm", data, null, true);
};

export const PostAgentRejectChat = async (data) => {
  return await ApiRequestNoLoder("POST", "chat/reject", data, null, true);
};

// SSE endpoint: POST /chat
// handlers: { onResult, onError, onDone }
export const PostAgentChatStream = async (data, handlers = {}) => {
  const host = getHost();
  const token = localStorage.getItem("token");
  const authHeader = token ? `Bearer ${token}` : "";

  const response = await fetch(`${host}chat`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-User-Id": getUserId(),
      "Authorization": authHeader,
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  if (!response.body) {
    // Fallback in case proxy/server returns normal JSON instead of SSE.
    const fallback = await response.json().catch(() => null);
    if (fallback) return fallback;
    throw new Error("No stream body");
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let lastResult = null;
  let streamError = null;

  const flushEvents = () => {
    // Support both proper SSE newlines and escaped newline payloads from proxies.
    const normalized = buffer.replace(/\r\n/g, "\n");
    const separators = ["\n\n", "\\n\\n"];
    let cursor = 0;

    const chunks = [];
    while (cursor < normalized.length) {
      let nextIndex = -1;
      let usedSep = "";
      for (const sep of separators) {
        const idx = normalized.indexOf(sep, cursor);
        if (idx !== -1 && (nextIndex === -1 || idx < nextIndex)) {
          nextIndex = idx;
          usedSep = sep;
        }
      }
      if (nextIndex === -1) break;
      chunks.push(normalized.slice(cursor, nextIndex));
      cursor = nextIndex + usedSep.length;
    }

    buffer = normalized.slice(cursor);
    return chunks;
  };

  const processEvents = (events) => {
    for (const evt of events) {
      let chunk = evt.trim();
      // Some proxies/devtools surfaces payload as a quoted string literal.
      if (chunk.startsWith("\"") && chunk.endsWith("\"")) {
        try {
          chunk = JSON.parse(chunk);
        } catch {
          // keep as-is
        }
      }
      chunk = chunk.replace(/\\r\\n/g, "\n").replace(/\r\n/g, "\n");

      const dataEntries = [];
      const regex = /(?:^|\n|\\n)data:\s*(.+?)(?=(?:\n|\\n)data:|$)/gs;
      let match;
      while ((match = regex.exec(chunk)) !== null) {
        dataEntries.push(match[1].trim());
      }

      for (const payloadRaw of dataEntries) {
        if (payloadRaw === "[DONE]") {
          if (handlers.onDone) handlers.onDone();
          continue;
        }
        try {
          const parsed = JSON.parse(payloadRaw);
          if (parsed?.type === "result") {
            lastResult = parsed.payload ?? parsed;
            if (handlers.onResult) handlers.onResult(parsed.payload);
          } else if (parsed?.type === "error") {
            streamError = parsed.error || "Stream error";
            if (handlers.onError) handlers.onError(parsed.error || "Stream error");
          }
        } catch {
          // ignore malformed SSE chunk
        }
      }
    }
  };

  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    processEvents(flushEvents());
  }

  // Final flush: handle streams that end without a trailing delimiter.
  const remaining = flushEvents();
  if (buffer.trim()) {
    remaining.push(buffer);
    buffer = "";
  }
  processEvents(remaining);

  if (streamError) {
    throw new Error(streamError);
  }
  if (lastResult) {
    return lastResult;
  }
  throw new Error("Empty stream response");
};


export const PostTriggerPotentialMatches = async (data) => {
  return await ApiRequest("POST", "admin/trigger-potential-matches", data);
};

export const PostUploadBiodata = async (userId, file) => {
  const formData = new FormData();
  formData.append('user_id', userId);
  formData.append('file', file);
  return await ApiRequest("POST", "admin/upload-biodata", formData);
};

export const PostUpdateProfilePhoto = async (userId, file) => {
  const formData = new FormData();
  formData.append('userId', userId);
  formData.append('file', file);
  return await ApiRequest("POST", "admin/v2/update-profile-photo", formData);
};

export const PostCreateSmmelanEvent = async (data) => {
  return await ApiRequest("POST", "admin/create-smmelan-even", data);
};

export const PostDeleteSammelanEvent = async (data) => {
  // Example request body:
  // { "sammelan_event_id": 123 }
  // Success response:
  // { "status": true, "data": { "id": 123, "name": "Sammelan Event April 2026", "deleted": true } }
  // Failure response if not found:
  // { "status": false, "detail": "Sammelan event not found" }
  return await ApiRequest("POST", "admin/sammelan-event-delete", data);
};

export const PostAssignUserSammelan = async (data) => {
  return await ApiRequest("POST", "admin/assign-user-sammelan", data);
};

export const PostRemoveUserSammelan = async (data) => {
  // Example request body:
  // { "user_id": "U123456789", "sammelan_event_id": 123 }
  // Success response:
  // { "status": true, "message": "User removed from Sammelan", "data": { "user_id": "U123456789", "sammelan_event_id": 123 } }
  // Failure response if not assigned:
  // { "status": false, "message": "User was not assigned to this Sammelan" }
  return await ApiRequest("POST", "admin/remove-user-sammelan", data);
};

export const PostUpdateProfileDetails = async (data) => {
  return await ApiRequest("POST", "admin/v2/update-profile-details", data);
};

export const PostSammelanEventStatus = async (data) => {
  return await ApiRequest("POST", "admin/sammelan-event-status", data);
};

export const PostPhoneCallFeedback = async (data) => {
  return await ApiRequest("POST", "admin/v2/submit-adminfeedback", data);
};

export const PostCreateCoupon = async (data) => {
  return await ApiRequest("POST", "admin/coupons", data);
};

export const PostCreateCreditPackage = async (data) => {
  return await ApiRequest("POST", "admin/credit-packages", data);
};

// Special Preference Notes (uses X-User-Id header to identify target user)
export const PostSpecialPreferenceNotes = async (data, userId) => {
  const rawHost = localStorage.getItem("apiHost") || "http://localhost:8008/";
  const host = rawHost.endsWith("/") ? rawHost : `${rawHost}/`;
  const token = localStorage.getItem("token");
  const res = await fetch(`${host}profile/special-preference-notes?user_id=${encodeURIComponent(userId)}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "Authorization": token ? `Bearer ${token}` : "", "X-User-Id": userId },
    body: JSON.stringify(data),
  });
  return await res.json();
};

export const PostBackfillSpecialPreferencesFromInstructions = async ({
  userId,
  dryRun = true,
  limit = /** @type {number | undefined} */ (undefined),
  activeOnly = true,
} = {}) => {
  const rawHost = localStorage.getItem("apiHost") || "http://localhost:8008/";
  const host = rawHost.endsWith("/") ? rawHost : `${rawHost}/`;
  const token = localStorage.getItem("token");
  const params = new URLSearchParams({
    dry_run: String(dryRun),
    active_only: String(activeOnly),
  });
  if (userId) params.set("user_id", userId);
  if (limit) params.set("limit", String(limit));
  const res = await fetch(`${host}profile/special-preference-notes/backfill-from-instructions?${params}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "Authorization": token ? `Bearer ${token}` : "" },
  });
  return await res.json();
};

export const PatchSpecialPreferenceNotes = async (data, userId) => {
  const rawHost = localStorage.getItem("apiHost") || "http://localhost:8008/";
  const host = rawHost.endsWith("/") ? rawHost : `${rawHost}/`;
  const token = localStorage.getItem("token");
  const res = await fetch(`${host}profile/special-preference-notes?user_id=${encodeURIComponent(userId)}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json", "Authorization": token ? `Bearer ${token}` : "", "X-User-Id": userId },
    body: JSON.stringify(data),
  });
  return await res.json();
};

export const DeleteSpecialPreferenceNotes = async (userId) => {
  const rawHost = localStorage.getItem("apiHost") || "http://localhost:8008/";
  const host = rawHost.endsWith("/") ? rawHost : `${rawHost}/`;
  const token = localStorage.getItem("token");
  const res = await fetch(`${host}profile/special-preference-notes?user_id=${encodeURIComponent(userId)}`, {
    method: "DELETE",
    headers: { "Content-Type": "application/json", "Authorization": token ? `Bearer ${token}` : "", "X-User-Id": userId },
  });
  return await res.json();
};

export const PostRemoveSpecialPreferenceKey = async (data, userId) => {
  const rawHost = localStorage.getItem("apiHost") || "http://localhost:8008/";
  const host = rawHost.endsWith("/") ? rawHost : `${rawHost}/`;
  const token = localStorage.getItem("token");
  const res = await fetch(`${host}profile/special-preference-notes/remove-key?user_id=${userId}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "Authorization": token ? `Bearer ${token}` : "", "X-User-Id": userId },
    body: JSON.stringify(data),
  });
  return await res.json();
};

export const PostAddPdfSale = async (data) => {
  return await ApiRequest("POST", "admin/add-pdf-sale", data);
};

export const PostProcessCallingPdfs = async () => {
  return await ApiRequest("POST", "admin/process-calling-pdfs");
};

export const PostBulkUpdateUnregisteredStatus = async (fromStatus, toStatus, userId = null) => {
  const body = {
    from_status: fromStatus,
    to_status: toStatus,
  };
  if (userId) {
    body.user_id = Array.isArray(userId) ? userId : [userId];
  }
  
  return await ApiRequest(
    "POST",
    "admin/bulk-update-unregistered-status",
    body
  );
};

export const PatchAssignUserToSelf = async (userId) => {
  return await ApiRequest("PATCH", `admin/users/${userId}/assign-self`, {});
};

export const PostDeactivatePair = async (data) => {
  return await ApiRequestNoLoder("POST", "admin/deactivate-pair", data);
};

export const PostSendWhatsappTemplateBulk = async (data) => {
  return await ApiRequest("POST", "admin/whatsapp/send-template-bulk", data);
};

export const PostWhatsappRecipientCount = async (data) => {
  return await ApiRequestNoLoder("POST", "admin/whatsapp/recipient-count", data);
};

export const PostSyncWhatsappDbTemplatesFromMeta = async (limit = 250) => {
  return await ApiRequest("POST", `admin/whatsapp/db-templates/sync-meta?limit=${limit}`, {});
};

export const PostCreateWhatsappDbTemplate = async (data) => {
  return await ApiRequest("POST", "admin/whatsapp/db-templates", data);
};

export const PatchWhatsappDbTemplate = async (templateIdOrKey, data) => {
  return await ApiRequest(
    "PATCH",
    `admin/whatsapp/db-templates/${encodeURIComponent(templateIdOrKey)}`,
    data,
  );
};

export const PostSendWhatsappDbTemplateBulk = async (templateIdOrKey, data) => {
  return await ApiRequest(
    "POST",
    `admin/whatsapp/db-templates/${encodeURIComponent(templateIdOrKey)}/send-bulk`,
    data,
  );
};

export const PostCreateWhatsappTemplate = async (data) => {
  return await ApiRequest("POST", "admin/whatsapp/create-template", data);
};

export const PostWhatsappTemplateHeaderSample = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return await ApiRequest("POST", "admin/whatsapp/template-header-sample", formData);
};

export const PostUploadWhatsappTemplateHeaderImage = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return await ApiRequest("POST", "admin/v2/upload-image", formData);
};

export const PatchWhatsappMetaTemplate = async (templateId, data) => {
  return await ApiRequest("PATCH", `admin/whatsapp/meta-templates/${encodeURIComponent(templateId)}`, data);
};

export const UploadGooglePlayReport = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return await ApiRequest("POST", "admin/devices/google-play/upload-report", formData);
};

export const SaveGooglePlayOAuthConfig = async (data) => {
  return await ApiRequest("POST", "admin/devices/google-play/oauth/config", data);
};

export const DisconnectGooglePlayOAuth = async () => {
  return await ApiRequest("POST", "admin/devices/google-play/oauth/disconnect", {});
};

